import type { FC } from "react";
import { Breadcrumbs } from "@hightouch/htui";

import { directoryBreadcrumbs } from "src/components/asset-picker/build-directory-tree";

type Props = {
  directory: string;
  /** Null means back to every folder in the collection. */
  onSelect: (directory: string | null) => void;
};

export const FolderBreadcrumbs: FC<Props> = ({ directory, onSelect }) => {
  const folders = directoryBreadcrumbs(directory);
  return (
    <Breadcrumbs
      aria-label="Folder path"
      items={[
        { label: "All", onClick: () => onSelect(null) },
        ...folders.map((folder, index) => ({
          label: folder.name,
          onClick:
            index < folders.length - 1
              ? () => onSelect(folder.path)
              : undefined,
        })),
      ]}
    />
  );
};
